import { Badge } from '../ui/badge';
import { cn } from '../../lib/utils';
import type { SystemMode, KillSwitchStatus, AlertSeverity } from '../../types';

type OrderStatusType = 'PENDING' | 'FILLED' | 'CANCELLED' | 'REJECTED';
type Mt5StatusType = 'pending' | 'claimed' | 'executed' | 'failed' | 'expired';
type StatusType =
  | SystemMode
  | KillSwitchStatus
  | AlertSeverity
  | 'LONG'
  | 'SHORT'
  | 'WIN'
  | 'LOSS'
  | OrderStatusType
  | Mt5StatusType;

interface StatusBadgeProps {
  status: StatusType | string;
  className?: string;
}

const statusConfig: Record<string, { label: string; className: string }> = {
  NORMAL: { label: 'Normal', className: 'bg-green-500/10 text-green-500 border-green-500/20' },
  PAUSED: { label: 'Paused', className: 'bg-yellow-500/10 text-yellow-500 border-yellow-500/20' },
  PRESERVATION: { label: 'Preservation', className: 'bg-orange-500/10 text-orange-500 border-orange-500/20' },
  DISABLED: { label: 'Disabled', className: 'bg-red-500/10 text-red-500 border-red-500/20' },
  ON: { label: 'ON', className: 'bg-red-500/10 text-red-500 border-red-500/20' },
  OFF: { label: 'OFF', className: 'bg-green-500/10 text-green-500 border-green-500/20' },
  INFO: { label: 'Info', className: 'bg-blue-500/10 text-blue-500 border-blue-500/20' },
  WARN: { label: 'Warning', className: 'bg-yellow-500/10 text-yellow-500 border-yellow-500/20' },
  ERROR: { label: 'Error', className: 'bg-red-500/10 text-red-500 border-red-500/20' },
  HIGH: { label: 'High', className: 'bg-orange-500/10 text-orange-500 border-orange-500/20' },
  CRITICAL: { label: 'Critical', className: 'bg-red-600/10 text-red-600 border-red-600/20' },
  LONG: { label: 'Long', className: 'bg-green-500/10 text-green-500 border-green-500/20' },
  SHORT: { label: 'Short', className: 'bg-red-500/10 text-red-500 border-red-500/20' },
  WIN: { label: 'Win', className: 'bg-green-500/10 text-green-500 border-green-500/20' },
  LOSS: { label: 'Loss', className: 'bg-red-500/10 text-red-500 border-red-500/20' },
  PENDING: { label: 'Pending', className: 'bg-yellow-500/10 text-yellow-500 border-yellow-500/20' },
  FILLED: { label: 'Filled', className: 'bg-green-500/10 text-green-500 border-green-500/20' },
  CANCELLED: { label: 'Cancelled', className: 'bg-muted text-muted-foreground border-muted' },
  REJECTED: { label: 'Rejected', className: 'bg-red-500/10 text-red-500 border-red-500/20' },
  pending: { label: 'Pending', className: 'bg-yellow-500/10 text-yellow-500 border-yellow-500/20' },
  claimed: { label: 'Claimed', className: 'bg-blue-500/10 text-blue-500 border-blue-500/20' },
  executed: { label: 'Executed', className: 'bg-green-500/10 text-green-500 border-green-500/20' },
  failed: { label: 'Failed', className: 'bg-red-500/10 text-red-500 border-red-500/20' },
  expired: { label: 'Expired', className: 'bg-muted text-muted-foreground border-muted' },
};

export function StatusBadge({ status, className }: StatusBadgeProps) {
  const config = statusConfig[status] || { label: status, className: '' };

  return (
    <Badge variant="outline" className={cn(config.className, className)}>
      {config.label}
    </Badge>
  );
}
